import {asset} from '@/lib/asset';

export function SiteFooter() {
  return (
    <footer className="border-t border-white/8 bg-pine-950">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 px-4 py-12 sm:flex-row sm:justify-between sm:px-6">
        <div className="flex items-center gap-5">
          <img src={asset('img/logos/nm26.webp')} alt="Navimarket 26" className="h-12 w-auto" loading="lazy" />
          <span aria-hidden className="h-8 w-px bg-white/15" />
          <img src={asset('img/logos/ath-movil-w.webp')} alt="ATH Móvil" className="h-6 w-auto" loading="lazy" />
        </div>
        <p className="text-center text-sm leading-relaxed text-cream/70 sm:text-right">
          Navimarket 2026 · Un evento de ATH Móvil / Evertec
          <br />
          <a
            href="https://athmovil.com"
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-4 transition-colors hover:text-cream"
          >
            athmovil.com
          </a>
        </p>
      </div>
    </footer>
  );
}
